export default __webpack_public_path__ + "static/media/5.abf4ec3d.png";